var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(!_vm.loading)?_c('company-form',{attrs:{"title":'companies.edit_company',"initialCompany":_vm.company},on:{"save":_vm.save,"cancel":_vm.cancel}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }